let url = "https://api.wholesalecart.com/v2";
export default url;
